import React, { useEffect, useRef, useState } from 'react';
import Webcam from 'react-webcam';
import jsQR from 'jsqr';
import QRCode from 'qrcode.react';
import './App.css';

function App() {
  const webcamRef = useRef(null);
  const [qrCodeData, setQrCodeData] = useState('');
  const [scanning, setScanning] = useState(true);

  useEffect(() => {
    let active = true;

    const capture = () => {
      if (!active || !webcamRef.current) return;

      const imageSrc = webcamRef.current.getScreenshot();
      if (!imageSrc) return;

      const image = new Image();
      image.onload = () => {
        if (!active) return;

        const canvas = document.createElement('canvas');
        const scale = 2;
        canvas.width = image.width * scale;
        canvas.height = image.height * scale;
        const ctx = canvas.getContext('2d');
        ctx.scale(scale, scale);
        ctx.drawImage(image, 0, 0);

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const code = jsQR(imageData.data, imageData.width, imageData.height);
        if (code) {
          setQrCodeData(code.data);
          setScanning(false);
          active = false;
        }
      };
      image.src = imageSrc;
    };

    const intervalId = window.setInterval(capture, 250);
    return () => {
      active = false;
      window.clearInterval(intervalId);
    };
  }, []);

  return (
    <div className='app-container'>
      <Webcam
        audio={false}
        height={300}
        ref={webcamRef}
        screenshotFormat='image/jpeg'
        width={300}
        videoConstraints={{ facingMode: 'environment' }}
      />
      {scanning && <p>Scanning...</p>}
      {qrCodeData && (
        <div>
          <p className='left-text'>Scanned QR Code:</p>
          <div>
            <QRCode value={qrCodeData} />
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
